<template>
  <div>
    <v-layout justify-center wrap>
      <v-flex xs12>
        <v-layout justify-center wrap>
          <v-flex xs12 sm12 md6 lg6>
            <v-img
              src="./../../assets/images/Mask Group 12/Mask Group 12.png"
              :style="{
                height: $vuetify.breakpoint.name == 'xs' ? '200px' : '600px',
              }"
            ></v-img>
          </v-flex>
          <v-flex xs12 sm12 md6 lg6>
            <v-img
              src="./../../assets/images/Mask Group 15/Mask Group 15.png"
              :style="{
                height: $vuetify.breakpoint.name == 'xs' ? '200px' : '600px',
              }"
            >
              <v-layout
                justify-center
                pt-0
                pt-sm-16
                pt-md-16
                pt-lg-16
                pt-xl-16
                wrap
              >
                <v-flex xs12 sm12 md8 lg8 pt-16 text-end pa-2>
                  <span
                    :class="
                      $vuetify.breakpoint.name == 'xs' ? 'subheadxs' : 'subhead'
                    "
                    >We project the futuristic</span
                  >
                  <br />
                  <span
                    :class="
                      $vuetify.breakpoint.name == 'xs' ? 'subheadxs' : 'subhead'
                    "
                    >vision of smart enterprising</span
                  >
                  <br />
                  <br>
                  <span
                    :class="
                      $vuetify.breakpoint.name == 'xs' ? 'subhead1xs' : 'subhead1'
                    "
                    >Our service aim to reach to the Micro to medium <br />
                    sized enterprises in their ever increasing need <br />
                    of Data Management.</span
                  >
                </v-flex>
              </v-layout>
            </v-img>
          </v-flex>
        </v-layout>
        <v-card color="#F2F2F2">
          <v-layout justify-center wrap pb-16 pt-5>
            <v-flex xs12 sm12 md8 lg8 xl8>
              <v-tabs
                v-model="tab1"
                hide-slider
                color="#00000"
                background-color="#F2F2F2"
                grow
                height="100px"
                class="notactive"
              >
                <v-tab class="pt" v-for="(list, index) in items1" :key="index">
                  <span :class="tab1 == index ? 'imactive1' : 'notactive1'">
                    {{ list }}
                  </span>
                </v-tab>
                <v-tab-item>
                  <v-layout justify-center wrap>
                    <v-flex xs12 pt-10>
                      <v-card outlined color="white">
                        <v-layout justify-center wrap>
                          <v-flex xs12 sm12 md11 pa-2>
                            <span class="servicesub2Head"
                              >DMAAC is an initiative to provide Back office
                              support.</span
                            >
                            <br />
                            <br />
                            <span class="servicesub2Text"
                              >Our service aim to reach to the Micro to medium
                              sized enterprises <br />
                              in their ever increasing need of Data
                              Management.</span
                            >
                          </v-flex>
                          <v-flex xs11 py-5>
                            <v-divider></v-divider>
                          </v-flex>
                        </v-layout>
                        <v-layout justify-center wrap>
                          <v-flex xs10>
                            <v-layout justify-center wrap>
                              <v-flex
                                text-center
                                xs12
                                sm4
                                md4
                                lg4
                                xl4
                                pa-2
                                v-for="(list, index) in itemArray1"
                                :key="index"
                              >
                                <v-img
                                  class="align-end"
                                  width="150px"
                                  height="150px"
                                  contain
                                  :src="list.image"
                                >
                                </v-img>
                                <v-layout
                                  wrap
                                  justify-start
                                  class="bgClass"
                                  style="cursor: pointer"
                                >
                                  <v-flex
                                    xs12
                                    sm12
                                    md12
                                    pa-4
                                    pt-5
                                    align-self-end
                                    text-left
                                  >
                                    <v-layout wrap>
                                      <v-flex lg7>
                                        <span class="text1">{{
                                          list.name
                                        }}</span>
                                      </v-flex>
                                      <v-spacer></v-spacer>
                                      <v-flex
                                        lg1
                                        pt-2
                                        pt-sm-8
                                        pt-md-8
                                        pt-lg-8
                                        pt-xl-8
                                      >
                                        <span>></span>
                                      </v-flex>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-tab-item>
              </v-tabs>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tab1: null,
      items: [
        " System Implementation",
        "  Data Handling",
        " Digital Analytics",
      ],
      items1: [
        " System Implementation",
        "  Data Handling",
        " Digital Analytics",
      ],
      itemArray1: [
        {
          image: require("./../../assets/images/Group 8944.svg"),
          name: "Process ReEngineering",
        },
        {
          image: require("./../../assets/images/Group 8723.svg"),
          name: "Vendor Selection",
        },
        {
          image: require("./../../assets/images/Group 8675.svg"),
          name: "Implementation Partnership",
        },
      ],
    };
  },
};
</script>
<style>
.imactive {
  color: #ffffff !important;
  font-family: ibmplexsanssemibold;
  font-size: 20px !important;
  text-transform: none !important;
  padding-bottom: 6px;
  border-bottom: 4px solid #0038ff;
}
.notactive {
  color: #bfbfbf !important;
  font-family: ibmplexsanssemibold;
  font-size: 12px !important;
}
.imactive1 {
  color: black !important;
  font-family: ibmplexsanssemibold;
  font-size: 20px !important;
  text-transform: none !important;
  padding-bottom: 6px;
  border-bottom: 4px solid #0038ff;
}
.notactive1 {
  color: black !important;
  font-family: ibmplexsanssemibold;
  font-size: 12px !important;
}
.text1 {
  /* color: #000000; */
  font-family: ibmplexsanssemibold;
  font-size: 18px;
}
.bgClass :hover {
  background-color: #008fdb;
  color: #ffffff;
}
/* .pt{
    padding-bottom: 40px;
} */
</style>
